import { ToEntity } from 'core/common/mappers';
import { FunnelConfig, LightFlow, LightFunnel } from '../entities';
import { FlowDto, FunnelDto, LightFlowDto, LightFunnelDto } from '../services';

export class FunnelDtoMapper implements ToEntity<FunnelConfig, FunnelDto> {
  toEntity(dto: FunnelDto): FunnelConfig {
    return {
      id: dto.id,
      link: dto.link,
      flows: dto.flows.map((flow: FlowDto) => ({
        id: flow.id,
        name: flow.name,
        initialScreen: flow.initial_screen,
        language: flow.language,
        offers: flow.offers,
        screens: flow.screens,
        translations: flow.translations,
        attributes: flow.attributes,
        appearance: flow.appearance,
      })),
      name: dto.name,
      analytics: dto.analytics,
      attributes: dto.attributes,
      offers: dto.offers,
      project: {
        id: dto.project.id,
        name: dto.project.name,
        attributes: dto.project.attributes ?? {},
      },
    };
  }

  toLightEntity(dto: LightFunnelDto): LightFunnel {
    return {
      name: dto.name,
      analytics: dto.analytics,
      flows: dto.flows.map((flow) => this.toLightFlowEntity(flow)),
    };
  }

  private toLightFlowEntity(flow: LightFlowDto): LightFlow {
    return {
      name: flow.name,
      initialScreen: flow.initial_screen,
      language: flow.language,
    };
  }
}
